// extracted by mini-css-extract-plugin
export default {"graphWrapper":"styles_graph-wrapper__i7zmK"};